import axios, { AxiosInstance } from "axios";


export const apiClient: AxiosInstance = axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        headers: {
                'Content-Type': 'application/json',
        },
});

apiClient.interceptors.request.use(
        (config) => {
                const token = localStorage.getItem('authToken');
                if (token) {
                        config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
        },
        (error) => {
                const { status } = error.response || {};
                if (status === 401) {
                        localStorage.removeItem('authToken');
                        window.location.href = '/';
                }
                else if (status === 500) {
                        alert('Internal Server Error. Please try again later.');
                }
                return Promise.reject(error);
        }
);
